import React from 'react';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';

const AdminReadOnlyBanner = () => {
  const { isViewer, roleLabel, roleReady } = useAdminPermissions();

  if (!roleReady || !isViewer) return null;

  return (
    <div
      className="alert alert-warning d-flex align-items-center gap-2 mb-0 rounded-0 border-0 border-bottom py-2 px-3"
      role="status"
    >
      <i className="bi bi-eye-fill" aria-hidden />
      <span className="small mb-0">
        <strong>{roleLabel}:</strong> solo lectura. No puedes crear, editar ni eliminar registros.
      </span>
    </div>
  );
};

export default AdminReadOnlyBanner;
